import {
  RESOLVE_BY_REPLACE_ENTRIES,
  ResolveActions,
  ResolveByReplaceEntries,
} from '../actions/conflict';

export function isReplaceAction(action: ResolveActions): action is ResolveByReplaceEntries {
  return action.type === RESOLVE_BY_REPLACE_ENTRIES;
}
